var quizQuestions = [
  {
    question: "Seat belts reduce the risk of injury or death in a serious crash by 30%.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>Seat belts reduce your risk of a crash-related injury or death by half</strong>. In fact, the Florida Department of Highway Safety and Motor Vehicles claim that buckling up is the most effective way to protect yourself from physical harm in a car crash.",
    correctAnswer: "b"
  },
  {
    question: "Floridians over 18 years old are not required to wear a seat belt.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "While all Floridians under the age of 18 must wear a seat belt at all times while in a car, <strong>you are required to wear a seat belt in a front seat regardless of your age</strong>.",
    correctAnswer: "b"
  },
  {
    question: "A car's high beam headlights must show objects that are how many feet ahead?",
    answers: {
      a: "150 feet",
      b: "250 feet",
      c: "350 feet",
      d: "450 feet"
    },
    description: "Florida Department of Safety and Motor Vehicles requires <strong>high beam headlights to show objects that are 450 feet ahead of your car</strong> and low beam headlights that are 150 feet ahead. Both must be visible from 1,000 feet away.",
    correctAnswer: "d"
  },
  {
    question: "You can wear headphones or a headset while driving.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "While wearing a headset or Bluetooth piece may create a \"hands free\" way to talk on the phone and seem like a safe option, <strong>it is illegal</strong>. This is because most emergency vehicles are equipped with sirens that are difficult to hear if you are wearing headphones or similar devices.",
    correctAnswer: "b"
  },
  {
    question: "What does this sign mean?<br /><img src=\"/images/quiz/quiz6.jpg\" alt=\"Road Sign\" />",
    answers: {
      a: "It alerts the driver about a nearing construction zone",
      b: "It is warning of an approaching hazard on the road",
      c: "It's for vehicles that drive less than 25 mph",
      d: "It's for cars with an impaired person behind-the-wheel"
    },
    description: "If a vehicle that cannot drive above 25 mph is on a public road, it must display the orange triangle sign on its rear.",
    correctAnswer: "c"
  },
  {
    question: "Drowsy driving causes which of the following?",
    answers: {
      a: "Slows your thought process",
      b: "Affects your judgement",
      c: "Causes micro-sleeping",
      d: "All of the above"
    },
    description: "Driving drowsy can be as deadly as drunk driving. It can <strong>slow down your thought process, affect your judgement and cause micro-sleeping</strong>, which is when you \"nod off\" without actually falling asleep. However, drowsy driving can cause you to fall completely asleep behind the wheel and impair your senses as well.",
    correctAnswer: "d"
  },
  {
    question: "Which of these is not a category of distracted driving?",
    answers: {
      a: "Visual",
      b: "Audible",
      c: "Manual",
      d: "Cognitive"
    },
    description: "<strong>Correct Answer: <span class=\"answer\">B</span></strong><br /> While sounds can create a distraction, the three main categories are: visual &mdash; anything that takes your eyes off the road, manual &mdash; anything that takes your hands off the steering wheel, and cognitive &mdash; anything that takes your thoughts away from driving.",
    correctAnswer: "b"
  },
  {
    question: "How many years will a DUI conviction remain on your record?",
    answers: {
      a: "25 years",
      b: "50 years",
      c: "75 years",
      d: "100 years"
    },
    description: "<strong>Correct Answer: <span class=\"answer\">C</span></strong><br />Once you have been convicted of a DUI, that conviction will remain on your record for <strong>75 years</strong>. This means anyone from future employers to car insurance companies have legal access to this information.",
    correctAnswer: "c"
  },
  {
    question: "When backing up your car, you should always look over your left shoulder.",
    answers: {
      a: "You cannot pass, but you are free to use either lane",
      b: "You can pass, but you must drive on the right side of the line",
      c: "You can pass, and you are free to use both lanes",
      d: "You cannot pass, but you are free to use both lanes"
    },
    description: "If the line is solid, you cannot pass. <strong>A broken yellow line means you can pass, but must drive on the right side of the line.</strong> You also should not pass unless it is safe to do so.",
    correctAnswer: "b"
  },
  {
    question: "When a road sign is green, it generally provides the driver with what information?",
    answers: {
      a: "A regulation",
      b: "Direction guidance",
      c: "A general warning",
      d: "Scenic guidance"
    },
    description: "Green signs usually indicate permitted movements and <strong>directional guidance</strong>. Brown signs, on the other hand, give motorists public recreation information and scenic guidance.",
    correctAnswer: "b"
  },
  {
    question: "A diamond-shaped sign conveys what kind of information to drivers?",
    answers: {
      a: "It signals a no passing zone",
      b: "It tells drivers they're in a school zone",
      c: "It warns drivers of hazards ahead",
      d: "It informs drivers of regulatory information"
    },
    description: "<strong>Diamond-shaped signs will warn drivers of existing or possible hazards ahead on the road</strong>. Pennant signs warn of no passing zones. Pentagon signs tell drivers about school zones. Vertical-rectangle signs provide regulatory information.",
    correctAnswer: "c"
  },
  {
    question: "What does this sign mean?<br /><img src=\"/images/quiz/quiz9.jpg\" alt=\"Road Sign\" />",
    answers: {
      a: "Sharp turn ahead",
      b: "One-lane road ahead",
      c: "Keep left ahead",
      d: "Lane reduction ahead"
    },
    description: "While this might mean you will have just one lane ahead, it doesn't necessarily mean that, as this sign is used when any lane is about to disappear regardless of how many will be left once it does.",
    correctAnswer: "d"
  },
  {
    question: "What does the following sign mean?<br /><img src=\"/images/quiz/quiz8.jpg\" alt=\"Road Sign\" />",
    answers: {
      a: "Lanes merge ahead",
      b: "Bridge ahead",
      c: "Road narrows ahead",
      d: "Uneven lanes ahead"
    },
    description: "This sign warns that you are <strong>approaching a bridge</strong>, indicating you should slow down and use caution.",
    correctAnswer: "b"
  },
  {
    question: "What information do brown and white signs tell you?",
    answers: {
      a: "511 Florida Department of Transportation information",
      b: "Directional and distance information, like mile markers and exit numbers",
      c: "Service information, telling drivers about presence of nearby hospitals, motels, gas stations etc.",
      d: "Scenic or cultural information, pointing out parks or places of historical importance"
    },
    description: "All <strong>signs regarding parks, scenic areas, or places of cultural or historical significance</strong> are brown and white. This is true not just in Florida but across the entire country.",
    correctAnswer: "d"
  },
  {
    question: "If an arrow light is flashing yellow, you must come to a complete stop and wait for it to turn green.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>A flashing yellow arrow light means you must yield to oncoming traffic, but, if it is safe to do so, you may turn</strong>. If the arrow light is a steady yellow, the light is about to turn red. If the arrow light is red, you are not allowed to turn.",
    correctAnswer: "b"
  },
  {
    question: "You cannot stop within 15 feet of a railroad crossing when crossing gates are lowering or lowered.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "According to the Florida Department of Safety and Motor Vehicles, you must stop <strong>between 50 feet and 15 feet</strong> from a railroad crossing.",
    correctAnswer: "a"
  },
  {
    question: "When the speed of your car doubles, the force of its impact is increased four times.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>Doubling the speed of your car will quadruple the force of its impact</strong>, and tripling the speed of your car will increase your impact nine times.",
    correctAnswer: "a"
  },
  {
    question: "Florida's standard speed limit in a school zone is:",
    answers: {
      a: "15 mph",
      b: "20 mph",
      c: "25 mph",
      d: "30 mph"
    },
    description: "Though school zones may have a higher or lower mph speed limit, <strong>Florida's standard is 20 mph.</strong>",
    correctAnswer: "b"
  },
  {
    question: "Rolling a stop is the number one citation teen drivers receive.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>The number one citation written for teens is speeding.</strong>",
    correctAnswer: "b"
  },
  {
    question: "You must drive in a clockwise direction in a roundabout.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>Roundabouts always travel in a counter-clockwise direction.</strong>",
    correctAnswer: "b"
  }
];
